var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.333H10M4.66667 9.99967H11.3333M3.33333 1.33301H12.6667C13.403 1.33301 14 1.99629 14 2.81449V13.1849C14 14.0031 13.403 14.6663 12.6667 14.6663H3.33333C2.59695 14.6663 2 14.0031 2 13.1849V2.81449C2 1.99629 2.59695 1.33301 3.33333 1.33301ZM7.9984 4.14097C7.53189 3.62154 6.75394 3.48182 6.16943 3.95746C5.58492 4.43309 5.50263 5.22834 5.96165 5.79087C6.42067 6.35341 7.9984 7.66634 7.9984 7.66634C7.9984 7.66634 9.57614 6.35341 10.0352 5.79087C10.4942 5.22834 10.4219 4.42809 9.82738 3.95746C9.23282 3.48682 8.46492 3.62154 7.9984 4.14097Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.6846e275b4c1a3e10ae0bd971bf3cdf5.svg";
export { ForwardRef as ReactComponent };